import i18n from "@/i18n";
import { Status } from "@shared/types/models";
import { PaymentStatus } from "@shared/types/payment";
import type { BankType } from "@shared/types/settings";

const CURRENCY = "KM";

const BANK_LOGOS: Record<BankType, string> = {
  ASA: "/assets/banks/asa.png",
  PROCREDIT: "/assets/banks/procredit-logo.png",
};

const statusToBadgeVariant = (status: Status): "paid" | "success" | "warning" | "destructive" | "info" | "secondary" => {
  switch (status) {
    case Status.PAID:
      return "paid";
    case Status.COMPLETED:
      return "success";
    case Status.PENDING:
      return "warning";
    case Status.PROCESSING:
      return "info";
    case Status.FAILED:
      return "destructive";
    case Status.SKIPPED:
      return "secondary";
    default:
      return "info";
  }
};

const statusToBadgeVariantRaw = (
  status: "PAID" | "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "SKIPPED",
): "paid" | "success" | "warning" | "destructive" | "info" | "secondary" => {
  switch (status) {
    case "PAID":
      return "paid";
    case "COMPLETED":
      return "success";
    case "PENDING":
      return "warning";
    case "PROCESSING":
      return "info";
    case "FAILED":
      return "destructive";
    case "SKIPPED":
      return "secondary";
    default:
      return "info";
  }
};

const getStatusBadgeVariant = (status: PaymentStatus): "success" | "destructive" | "warning" | "default" | "info" => {
  if (status === PaymentStatus.COMPLETED) return "success";
  if (status === PaymentStatus.FAILED) return "destructive";
  if (status === PaymentStatus.CANCELLED) return "warning";
  return "info";
};

const getStatusLabel = (status: PaymentStatus): string => {
  if (status === PaymentStatus.COMPLETED) return i18n.t("paymentLog.completed", { ns: "common" });
  if (status === PaymentStatus.FAILED) return i18n.t("paymentLog.failed", { ns: "common" });
  if (status === PaymentStatus.CANCELLED) return i18n.t("paymentLog.cancelled", { ns: "common" });
  return i18n.t("paymentLog.running", { ns: "common", defaultValue: "Running" });
};

export { BANK_LOGOS, CURRENCY, getStatusBadgeVariant, getStatusLabel, statusToBadgeVariant, statusToBadgeVariantRaw };
